import * as z from "zod";

export const REQUIRED_MESSAGE = "This field is required";

export const requiredString = () =>
  z
    .string({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: REQUIRED_MESSAGE,
    })
    .min(1, REQUIRED_MESSAGE);

export const zmessage = () => min(0, REQUIRED_MESSAGE);

export const requiredNumber = (message = "This field is required") =>
  z.number({
    required_error: REQUIRED_MESSAGE,
    invalid_type_error: REQUIRED_MESSAGE,
  });

export const requiredPositiveNumber = (
  message = "This field is required and must be positive",
) => requiredNumber().min(0, message);

export const dateSchema = z.preprocess(
  (arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  },
  z.date({
    required_error: REQUIRED_MESSAGE,
    invalid_type_error: REQUIRED_MESSAGE,
  }),
);

export const referenceObject = () =>
  z
    .object({
      id: requiredString(),
    })
    .or(z.literal(undefined)) // <- allow undefined safely
    .nullable()
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export function getRequiredFields(schema, parentKey = "") {
  return Object.entries(schema.shape).flatMap(([key, value]) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;

    if (value instanceof z.ZodObject) {
      // Recursively get required fields from nested objects
      return getRequiredFields(value, fullKey);
    }

    const isOptional =
      typeof value.isOptional === "function" ? value.isOptional() : false;

    return !isOptional ? [fullKey] : [];
  });
}

export const FileField = (required = true) =>
  z.any().superRefine((value, ctx) => {
    if (!required) return;
    if (value instanceof File) return;

    if (typeof value === "string" && value.trim().length > 0) return;

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: required ? REQUIRED_MESSAGE : undefined,
    });
  });
